export default {"src":"/_next/static/media/0x2039bb4116b4efc145ec4f0e2ea75012d6c0f181.cf54c71c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};